import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import './MyButton.css';
const ButtonStateEnum = {
  free: 0,
  hover: 0.5,
  pressed: 1,
}
const ButtonTypeEnum = {
  green: "green",
  white: "white",
  transparent: "transparent",
}

class MyButton extends Component {
    constructor(props){
      super(props);
      this.state = { buttonState: ButtonStateEnum.free };
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleMouseDown = this.handleMouseDown.bind(this);
      this.type = this.props?.type ?? ButtonTypeEnum.green;
      this.enabled = this.props?.enabled ?? true;
    }


    handleMouseEnter() {
      this.setState({ buttonState: ButtonStateEnum.hover });
    }
    handleMouseLeave() {
      this.setState({ buttonState: ButtonStateEnum.free });
    }
    handleMouseDown() {
      this.setState({ buttonState: ButtonStateEnum.pressed });
    }
    getColorStyle() {
      if (this.enabled) {
        if (this.state.buttonState === ButtonStateEnum.free){
          switch (this.type) {
            case ButtonTypeEnum.green:
              return {
                "backgroundColor": "var(--green100)",
                "borderColor": "var(--green100)",
                "color": "var(--white100)", 
              };
            case ButtonTypeEnum.white:
              return {
                "backgroundColor": "var(--white100)",
                "borderColor": "var(--green100)",
                "color": "var(--smoke180)", 
              };
            case ButtonTypeEnum.transparent:
              return {
                "backgroundColor": "transparent",
                "borderColor": "transparent", 
                "color": "var(--smoke180)", 
              };
            default:
              break;
          }
        }
        else if (this.state.buttonState === ButtonStateEnum.hover){
          switch (this.type) {
            case ButtonTypeEnum.green:
              return {
                "backgroundColor": "var(--green110)",
                "borderColor": "var(--green110)",
                "color": "var(--white100)", 
              };
            case ButtonTypeEnum.white:
              return {
                "backgroundColor": "var(--green100)",
                "borderColor": "var(--green100)",
                "color": "var(--white100)",
              };
            case ButtonTypeEnum.transparent:
              return {
                "backgroundColor": "var(--mantis10)",
                "borderColor": "var(--mantis10)", 
                "color": "var(--smoke180)", 
              };
            default:
              break;
          }
        }
        else if (this.state.buttonState === ButtonStateEnum.pressed){
          switch (this.type) {
            case ButtonTypeEnum.green:
              return {
                "backgroundColor": "var(--green120)",
                "borderColor": "var(--green120)",
                "color": "var(--white100)", 
              };
            case ButtonTypeEnum.white:
              return {
                "backgroundColor": "var(--green110)",
                "borderColor": "var(--green110)",
                "color": "var(--white100)",
              };
            case ButtonTypeEnum.transparent:
              return {
                "backgroundColor": "var(--mantis30)",
                "borderColor": "var(--mantis30)", 
                "color": "var(--smoke180)", 
              };
            default:
              break;
          }
        }
      }
      else { // disabled
        switch (this.type) {
          case ButtonTypeEnum.green:
            return {
              "backgroundColor": "var(--smoke60)",
              "borderColor": "var(--smoke60)",
              "color": "var(--white100)", 
            };
          case ButtonTypeEnum.white:
            return {
              "backgroundColor": "var(--white100)",
              "borderColor": "var(--smoke60)",
              "color": "var(--smoke60)", 
            };
          case ButtonTypeEnum.transparent:
            return {
              "backgroundColor": "var(--white100)",
              "borderColor": "var(--white100)", 
              "color": "var(--smoke60)", 
            };
          default:
            break;
        }
      }
    }
    isHover() {
      return this.state.buttonState === ButtonStateEnum.hover;
    }
    getStyle() {
      return {
        ...this.getColorStyle(),
        "scale": this.isHover() ? "1.0" : "1",
        "fontWeight": this.isHover() ? "800px" : "700px",
        "height":"50px",
        "fontFamily": 'Roboto',
        "fontStyle": 'normal',
        "fontSize": "20px",
        "lineHeight": "23px",        
        ...this.props?.style
      };
    }

    // getButtonContent(){
    //   var content = []
    //   if(this.props?.text){
    //     content.append(this.props.text)
    //   }
    //   if(this.props?.children){
    //     content.append(...this.props.children)
    //   }
    // }

    render () {
      let className = "button1" + (this.props?.className ? " " + this.props.className : "");
      let dataTooltipId = this.props?.dataTooltipId ?? "";
      if (this.props == null
        || ("innerHTML" in this.props && this.props.innerHTML == null)
      ){
        return null;
      }
      return (
          <Button data-tooltip-id={dataTooltipId} className={className}
              style={this.getStyle()}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              onMouseDown={this.handleMouseDown}
              onClick={() => this.props.onClick()}>
                    {this.props?.text}
                    <span 
                      dangerouslySetInnerHTML={{ __html: this.props?.innerHTML }}            
                    ></span>
                    {this.props?.children}
            </Button>
      )
    } 
}

export default MyButton;